/**
 * MPC External Demo 入口页面
 *
 * 导入本地 demo-routes 文件，传递给公共组件
 */

import React from 'react';
import { DemoEntry } from '@mpc/common/src/devtools/demo-router';
import { demoRoutes, isDemoMode } from '../../demo-routes';

export default function DemoPage() {
  return (
    <DemoEntry
      demoRoutes={demoRoutes}
      isDemoMode={isDemoMode}
      title="MPC External Demo 中心"
      emptyDescription="MPC External Demo 模式未启用"
    />
  );
}
